import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// content loaded
document.addEventListener('DOMContentLoaded', () => {


    // Default Slider
    const swiper = new Swiper('.swiper-default', {
        // Loop the slides
        loop: true,
        // Transition speed
        speed: 500,
        // Autoplay settings
        autoplay: {
            delay: 1000,
            disableOnInteraction: false,
        },
        // Disable/Enable draggable
        simulateTouch: true,
        // Spacing between slides
        spaceBetween: 30,
        // Slides per view
        slidesPerView: 2,
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });


    // Unity Hero Slider
    const unityHeroEl = document.querySelector('.unity-hero__swiper');
    if (unityHeroEl) {
        new Swiper('.unity-hero__swiper', {
            loop: true,
            speed: 800,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.unity-hero__pagination',
                clickable: true,
            },
        });
    }

    // Attention Adaptable Slider
    const attAdaptableEl = document.querySelector('.attention-adaptable__slider');
    if (attAdaptableEl) {
        new Swiper('.attention-adaptable__slider', {
            speed: 500,
            spaceBetween: 30,
            slidesPerView: 1.2,
            navigation: {
                nextEl: '.attention-adaptable__next',
                prevEl: '.attention-adaptable__prev',
            },
            breakpoints: {
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
                1200: { slidesPerView: 4 },
            },
        });
    }

    // Attention Partners Slider
    const attPartnersEl = document.querySelector('.attention-partners__slider');
    if (attPartnersEl) {
        new Swiper('.attention-partners__slider', {
            speed: 500,
            spaceBetween: 30,
            slidesPerView: 1.2,
            navigation: {
                nextEl: '.attention-partners__next',
                prevEl: '.attention-partners__prev',
            },
            breakpoints: {
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
                1200: { slidesPerView: 4 },
            },
        });
    }

    // MyClass Slider
    const mcsEl = document.querySelector('.mcs__swiper');
    if (mcsEl) {
        new Swiper('.mcs__swiper', {
            loop: true,
            speed: 600,
            navigation: {
                nextEl: '.mcs__btn-next',
                prevEl: '.mcs__btn-prev',
            },
            on: {
                slideChange: function () {
                    const realIndex = this.realIndex;
                    document.querySelectorAll('.mcs__text-item').forEach((item, i) => {
                        item.classList.toggle('is-active', i === realIndex);
                    });
                },
            },
        });
    }

    // Robo 3D: Slider — multi-card carousel, nav arrows on sides
    const r3dsEl = document.querySelector('.r3ds__swiper');
    if (r3dsEl) {
        new Swiper('.r3ds__swiper', {
            speed: 500,
            spaceBetween: 20,
            slidesPerView: 1,
            navigation: {
                nextEl: '.r3ds__btn-next',
                prevEl: '.r3ds__btn-prev',
            },
            breakpoints: {
                576: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 3, spaceBetween: 24 },
                992: { slidesPerView: 4, spaceBetween: 24 },
            },
        });
    }

    // Robo 3D: What's Included — responsive icon cards, side nav arrows
    // <575 = 1, 575+ = 2, 767+ = 3, 991+ = 4, 1199+ = 5
    const r3dwEl = document.querySelector('.r3dw__swiper');
    if (r3dwEl) {
        new Swiper('.r3dw__swiper', {
            speed: 500,
            spaceBetween: 16,
            slidesPerView: 1,
            navigation: {
                nextEl: '.r3dw__btn-next',
                prevEl: '.r3dw__btn-prev',
            },
            breakpoints: {
                575: { slidesPerView: 2, spaceBetween: 16 },
                767: { slidesPerView: 3, spaceBetween: 18 },
                991: { slidesPerView: 4, spaceBetween: 20 },
                1199: { slidesPerView: 5, spaceBetween: 20 },
            },
        });
    }

    // MyStemKits: Awards — responsive badges slider with side nav arrows
    const msaEl = document.querySelector('.msa__swiper');
    if (msaEl) {
        new Swiper('.msa__swiper', {
            speed: 500,
            spaceBetween: 10,
            slidesPerView: 2,
            navigation: {
                nextEl: '.msa__btn-next',
                prevEl: '.msa__btn-prev',
            },
            breakpoints: {
                575: { slidesPerView: 3 },
                767: { slidesPerView: 4 },
                991: { slidesPerView: 5 },
            },
        });
    }

    // Continuous Slider
    const swiperContinuous = new Swiper('.swiper-continous', {
        // Loop the slides
        loop: true,
        // Transition speed
        speed: 1500,
        // Autoplay settings
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        // Disable/Enable draggable
        simulateTouch: true,
        // Spacing between slides
        spaceBetween: 30,
        // Slides per view
        slidesPerView: 2,
    });
});

